// Colored letter avatar for a brand. Deterministic color from slug so each
// brand keeps the same identity across the app (sidebar, brand selector,
// portfolio cards). Palette reuses existing IconBadge tints so it stays
// aligned with the rest of the design system — no new color tokens.

const PALETTE = [
  "bg-channel-klaviyo-bg text-channel-klaviyo",
  "bg-cat-scale-bg text-cat-scale-fg",
  "bg-cat-keyword-bg text-cat-keyword-fg",
  "bg-cat-budget-bg text-cat-budget-fg",
  "bg-cat-bid-bg text-cat-bid-fg",
  "bg-channel-whatsapp-bg text-channel-whatsapp",
  "bg-cat-subject-bg text-cat-subject",
] as const;

function pickPalette(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function BrandAvatar({
  name,
  slug,
  size = "md",
}: {
  name: string;
  slug: string;
  size?: "sm" | "md" | "lg";
}) {
  const initial = (name || slug || "?").trim().charAt(0).toUpperCase();
  const tone = pickPalette(slug || name);
  const dim = size === "sm" ? "w-5 h-5 text-[10px]" : size === "lg" ? "w-9 h-9 text-base" : "w-7 h-7 text-xs";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-md font-semibold shrink-0 ${dim} ${tone}`}
      aria-hidden
    >
      {initial}
    </span>
  );
}
